/*
 * Module for demonstrating dynamic forms
*/

rs.module("development/codedemosdynamicforms",

    [ ],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl) {

            $.js(jsSelectors.currentForm).on("change", function () {

                $.get(backendUrl, { form: $(this).val() }, function (response) {

                    $.js(jsSelectors.formContainer).html(response);

                    var form = $.js(jsSelectors.form);

                    // Reset validation
                    $.validator.resetValidation(form);
                });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
